import script from "./NewsDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./NewsDetailComponent.vue?vue&type=style&index=0&id=83dbab5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83dbab5e"]])

export default __exports__